<template>
  <div>
    <div class="content">
      <div class="content-main">
        <p class="content-title">门店配置<un-lock/><page-desc/></p>
        <div class="content-input">
          <div class="content-input-left">
            <div class="content-input-item">
              <label>所属门店</label>
              <el-select v-model="shopId" placeholder="Select" class="select-item">
                <el-option v-for="item in shopIdArray" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="content-input-right">
            <div class="content-input-btn">
              <ElButtons type="primary" icon="search" v-loading="searchLoading" :disable="searchLoading" @click="getPage(true)"> 查询 </ElButtons>
              <!--            <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>-->
            </div>
          </div>

        </div>
      </div>
      <div class="content-main">
        <!--        <p class="content-title" style="padding-bottom: 16px;">用户权限</p>-->
        <div class="content-button">
          <div>
<!--            <el-button type="primary" @click="editHygieneShopDialog(-1)" size="default">添加</el-button>-->
          </div>
          <BtnGroup :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>
        </div>
        <div class="content-table">
          <el-table
              ref="multipleTableRef"
              :data="pageDataList"
              style="width: 100%; "
              v-loading="listLoading"
              size="default"
              border
          >
            <!--            <el-table-column property="id" label="ID" v-if="checkColList.indexOf('ID') > -1"/>-->
            <el-table-column property="shopName" label="所属门店" v-if="checkColList.indexOf('所属门店') > -1"/>
            <el-table-column property="openDate" label="打卡启用时间" v-if="checkColList.indexOf('打卡启用时间') > -1"/>
            <el-table-column property="title" label="周打卡上传截止时间" v-if="checkColList.indexOf('周打卡上传截止时间') > -1">
              <template #default="scope">
                {{scope.row.weekClose == 1?'周日':scope.row.weekClose == 2?'周一':scope.row.weekClose == 3?'周二':scope.row.weekClose == 4?'周三':scope.row.weekClose == 5?'周四':scope.row.weekClose == 6?'周五':scope.row.weekClose == 7?'周六':''}}
              </template>
            </el-table-column>
            <el-table-column property="title" label="月打卡上传截止时间" v-if="checkColList.indexOf('月打卡上传截止时间') > -1">
              <template #default="scope">
                <span v-if="scope.row.monthClose">{{scope.row.monthClose}}号</span>
              </template>
            </el-table-column>
            <el-table-column property="" label="状态" v-if="checkColList.indexOf('状态') > -1">
              <template #default="scope">
                <p :style="{color: scope.row.state == 2?'red':''}">{{scope.row.state == 0?'待启用':scope.row.state == 1?'已启用':scope.row.state == 2?'已停用':'' }}</p>
              </template>
            </el-table-column>
            <el-table-column label="操作" v-if="checkColList.indexOf('操作') > -1">
              <template #default="scope">
<!--                <el-space direction="vertical">-->
                  <el-button @click="editHygieneShopDialog(scope.$index,scope.row)" size="small" type="primary">编辑</el-button>
                  <el-button v-if="scope.row.state == 1" @click="updateState(scope.row, 0)" size="small" type="warning" v-loading="scope.row.updateLoading">停用</el-button>
                  <el-button v-if="scope.row.state == 0 || scope.row.state == 2" @click="updateState(scope.row, 1)" size="small" type="success" v-loading="scope.row.updateLoading">启用</el-button>
<!--                </el-space>-->
              </template>
            </el-table-column>
          </el-table>
          <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
          </el-pagination>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { getFormData, postFormData } from "@/api/api";
import {getShopHygienePageList, updateShopHygieneState} from "@/api/url";
import Dialog from "@/assets/js/dialog"
import BtnGroup from '../../components/BtnGroup'
import SearchComponents from "@/components/SearchComponents";
import unLock from "@/layout/components/unLock";
import hygieneShopDialog from "@/views/hygiene/components/hygieneShopDialog";
import ImgViewer from "@/assets/js/imageViewer";

export default {
  name: "HygieneShop",
  components: { BtnGroup, SearchComponents, unLock },
  data() {
    return {
      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,
      listLoading: false,
      searchLoading: false,
      updateLoading: false,

      shopIdArray: [
        {name: '不限', id: 0},
      ],
      shopIdArr:[],
      shopId: 0,

      // stateArray: [
      //   {label: '不限', value: -1},
      //   {label: '待展示', value: 0},
      //   {label: '已上架', value: 1},
      //   {label: '已下架', value: 2}
      // ],
      // state: -1,

      //刷新组
      colList: ['所属门店', '打卡启用时间', '周打卡上传截止时间', '月打卡上传截止时间', '状态', '操作'],
      checkColList: [],

      //搜索
      searchTypeList: [
        {label : '门店名称', value : 1},
      ],
      searchType: 1,
      searchValue: '',

    }
  },
  methods: {

    getSearchType(e) {
      this.searchType = e;
    },
    getSearchValue(e) {
      this.searchValue = e;
    },

    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },

    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['shopId'] = this.shopId;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getShopHygienePageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    formatTime(time) {
      let timestamp = time
      let newDate = new Date(parseInt(timestamp))
      let y = newDate.getFullYear();
      let m = newDate.getMonth()+1;
      let d = newDate.getDate();
      return  y + '-' + (m<10?'0'+m:m) + '-' + (d<10?'0'+d:d)
    },

    editHygieneShopDialog(idx, row) {
      let _title = '';
      let shopForm = {}
      if (idx > -1) {
        _title = '编辑门店配置'
        shopForm = Object.assign({}, row);
        // console.log(shopForm)
      }else {
        _title = '添加门店配置'
        // console.log(shopForm)
      }
      Dialog.open({
        title: _title,
        component: hygieneShopDialog,
        data: {
          shopForm: shopForm,
          ids: idx,
          width: '600px',
        },
        confirm: (result) => {
          this.getPage()
        }
      })
    },



    updateState(row,state) {
      this.$confirm('确认' + (state == 1?'启用【':'停用【') + row.shopName + '】的卫生打卡吗？').then(()=> {
        row.updateLoading = true;
        let param = {};
        param['id'] = row.id;
        postFormData(updateShopHygieneState, param).then((data)=>{
          let {code, msg} = data;
          if (code == 200) {
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'success'
            })
            this.getPage()
          }else {
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            })
          }
          row.updateLoading = false;
        }).catch(()=> {
          row.updateLoading = false;
        })
      })
    },

    showImg(img) {
      let imgList = []
      imgList.push(img)
      ImgViewer.open({
        imgList: imgList
      })
    },


  },
  mounted() {
    let ownShopList = JSON.parse(sessionStorage.getItem('ownShopList'))
    this.shopIdArray = this.shopIdArray.concat(ownShopList)
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    this.getPage();
  }
}
</script>

<style scoped>
/*.el-table {*/
/*  --el-table-header-bg-color: #ffffff !important;*/
/*}*/
.item-img {
  width: 80px;
  height: 80px;
}
</style>
